import styled from "styled-components";
import {hexToRgba} from "../../../../themes/hex-to-rgba";
import {baseColors} from "../../../../themes/definitions/mrgreen/base-colors";
import {HoverNavigationButtonContainerDefaultBox} from "./hover-navigation-button-container.default.box";

export const HoverNavigationButtonContainerMrGreenBox = styled(HoverNavigationButtonContainerDefaultBox)`
    color: ${props => hexToRgba(props.theme.colors.textDark,0.8)};
    border-radius: 50%;
    background: ${baseColors.base04};

    &:hover {
        color: ${props => props.theme.colors.textDark};
    }
`;
